import {useFormContext} from 'platform/components';

import {Controller} from 'react-hook-form';

import {TestIdProps} from 'shared/web';

import {useCatalogue} from '../../../../../hooks/useCatalogue';
import {EMPTY_PRESET_FEATURES} from '../consts/emptyPresetFeatures';
import {normalizePresetFeatures} from '../utils/normalizePresetFeatures';
import {PresetEditorFormValues} from '../utils/presetEditorFormSchema';
import {PresetFeaturesFieldContent} from './PresetFeaturesFieldContent';

interface PresetFeaturesFieldProps extends TestIdProps {
  isReadOnly?: boolean;
}

export function PresetFeaturesField(props: PresetFeaturesFieldProps) {
  const {isReadOnly} = props;
  const {control} = useFormContext<PresetEditorFormValues>();
  const {hasFeatureTranslation} = useCatalogue();

  return (
    <Controller
      name="features"
      control={control}
      render={({field}) => {
        const features =
          normalizePresetFeatures(field.value, hasFeatureTranslation) ?? EMPTY_PRESET_FEATURES;

        return (
          <PresetFeaturesFieldContent
            features={features}
            onFeaturesChange={(value) => {
              field.onChange(normalizePresetFeatures(value, hasFeatureTranslation));
            }}
            isReadOnly={isReadOnly}
            data-testid={props['data-testid']}
          />
        );
      }}
    />
  );
}
